
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as perfileewM5Q23l5PBJDz4_45c6UX2kJ9M7l_45vsVTSxI29qHS88Meta } from "/app/pages/app/perfil.vue?macro=true";
import { default as loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as indexk3qjL_45EPugk1CN1aNW9cdx4b2Y5dGkwkCKt1AHcEd0EMeta } from "/app/pages/planos/index.vue?macro=true";
import { default as dashboardE7ZV2C80zylvQncoM_JXQBzpHJsDlfXFAtT_4562Q8qOYMeta } from "/app/pages/app/dashboard.vue?macro=true";
import { default as indexJShk27dRSWfsze5T07DMDSKRnqsALdb8h6oYoL56uS0Meta } from "/app/pages/patient/index.vue?macro=true";
import { default as indexZw_2HO0SGP7IX_45I0OpXWUbnLJZ9gO_Q62StTRt1MiBYMeta } from "/app/pages/app/chat/index.vue?macro=true";
import { default as financeiroKO7wsko16NUgDQHACZLu_45wA68Vq_iSBUyjs2vF9GdewMeta } from "/app/pages/app/financeiro.vue?macro=true";
import { default as prontuarioAU0ay0bBcrEfJsYNetKfeM35cvShlb5xjy8iFmg9WOgMeta } from "/app/pages/app/prontuario.vue?macro=true";
import { default as agendaqXdXRBp_45P3_RlP3cTgm07H7x42VKfBz_45Nz8OWZn_45VrsMeta } from "/app/pages/patient/agenda.vue?macro=true";
import { default as diario4hRfFo_79RRdWkRWjyABRO9WCw75fFOAVWv__3ILROUMeta } from "/app/pages/patient/diario.vue?macro=true";
import { default as laudosHTjpCDVKBOlPMYJUjaBqHLZd1MWUPdkvykaN9__8uw4Meta } from "/app/pages/patient/laudos.vue?macro=true";
import { default as perfilexwVtMvcC6Qp7PfP1fPIp0UdkttAT9hsoqv1dIWsR7gMeta } from "/app/pages/patient/perfil.vue?macro=true";
import { default as termosFEzF7EFVlrnJ5pqNyqEcKfh06uqOkIkkIG_bDPnTP1oMeta } from "/app/pages/patient/termos.vue?macro=true";
import { default as _91id_93IHAkhNdirUMJfFAZyhVUkhwpP4NEA_45vx68HbLj1isqQMeta } from "/app/pages/app/agenda/[id].vue?macro=true";
import { default as fila05ayjfPF4fwJPxm7I__45QlvtxGrRBYgkq6AfcGMdD3k8Meta } from "/app/pages/app/agenda/fila.vue?macro=true";
import { default as novoAyOLnF5gexgJqVZiatSD1LgevnCwyu1esPy_hNn1y8cMeta } from "/app/pages/app/agenda/novo.vue?macro=true";
import { default as onboardingQcdr3TGwvGjMWxYkSzkIDOfyVHLITibtVzcIOyC8gFMMeta } from "/app/pages/auth/onboarding.vue?macro=true";
import { default as verify_452faN9EJkZ35rnsc7Ej2BoOCjjMCYUMs5M4lJADXBc22_45xMMeta } from "/app/pages/auth/verify-2fa.vue?macro=true";
import { default as indexCxnNs9xL3iKl5vgqQp6KsmuO4PneoOpXRe6dMW0S1IYMeta } from "/app/pages/app/agenda/index.vue?macro=true";
import { default as notificacoesP1pUvjWPoQW0eezFHHry__45NjFuwUdKzjooiha_QNDykMeta } from "/app/pages/app/notificacoes.vue?macro=true";
import { default as indexF1yEq2u7f1C87YLhNMmTgkiuLUM_45xyAPIMbGM_45A3qWoMeta } from "/app/pages/app/testes/index.vue?macro=true";
import { default as _91code_93lqD_45BDvWwunPNmSl0uPQFjr6EIOhne_KAK2qj25_452vYMeta } from "/app/pages/verificar/[code].vue?macro=true";
import { default as indexwjI4loSb7mMIH8poxQSfscmChVmGllhUdVGf6KXEK8cMeta } from "/app/pages/app/billing/index.vue?macro=true";
import { default as perfilxWbajx_EBAtZ77_45r4PLSOQVsICTuIOPmZodr_4545QHk4Meta } from "/app/pages/app/configuracoes/perfil.vue?macro=true";
import { default as permissoesuEmYyxwe1_45sURYWwU5GZWSqp2ouR2hGqoGZ4JAdyGpgMeta } from "/app/pages/app/configuracoes/permissoes.vue?macro=true";
import { default as configuracoes0GeQWU2LMjFYmopLG0tcBAXahkFJ7KHrdyP3jZuHlLYMeta } from "/app/pages/app/configuracoes.vue?macro=true";
import { default as google_45proxy7NrT_CY4XTdbqIH4J7cnMkPzyTtn8uiY_JtCDWRhc_45wMeta } from "/app/pages/auth/google-proxy.vue?macro=true";
import { default as _91token_93gfyTk9RLV0P5NhG6G26szJgdhvwRquJCf_92w0aaK6wMeta } from "/app/pages/confirmar/[token].vue?macro=true";
import { default as _91id_933Gp6OW_DRWxz_45BCEiubBHGrfCTKZdJvurtaaw_QT7xMMeta } from "/app/pages/app/pacientes/[id].vue?macro=true";
import { default as novolMJqSOn7250iaW0lFfkP8pwHg_45Y6pI7X2qm4wklEX6gMeta } from "/app/pages/app/pacientes/novo.vue?macro=true";
import { default as login_45patient5GX7LaTM629cXfeGuayZ32G54_ZfPV3kODO7djWpt6kMeta } from "/app/pages/auth/login-patient.vue?macro=true";
import { default as financeiroad_e4p8ipb0hEKeuXg_45m8m2NgbxKcwF59QP9U4opGxwMeta } from "/app/pages/patient/financeiro.vue?macro=true";
import { default as prontuarioS7MRm574px9oVRlS5m3QoFBuxoBto5R32CK73DlWhEsMeta } from "/app/pages/patient/prontuario.vue?macro=true";
import { default as indexOQ_45n7BeLg481nwu534ZdiQtF5y_45TfRCpWpP_45TJtlUaYMeta } from "/app/pages/app/auditoria/index.vue?macro=true";
import { default as indexBn04P8TSS7Lwfe010m9Xo_JkdttFSBP0AZpk5Nq047EMeta } from "/app/pages/app/checklist/index.vue?macro=true";
import { default as usuariostNZGNhzAQeafkZE8etZY7PgzrhIsNIfvaEk7FawTyuUMeta } from "/app/pages/app/equipe/usuarios.vue?macro=true";
import { default as index7pGc2Xv3_450qG_45_45ely4CFBgxFsHHcKF0LoQ0DprWOq9AMeta } from "/app/pages/app/pacientes/index.vue?macro=true";
import { default as reset_45passwordNpUsiQybcTLi_45Ke3wh24gyldOA9IXhGjC1yM32hGDDMMeta } from "/app/pages/auth/reset-password.vue?macro=true";
import { default as bloqueiosP00qJqwgImfX1Krh4rW4MtNc2liCl2jrVM2Up4R_45d0cMeta } from "/app/pages/app/agenda/bloqueios.vue?macro=true";
import { default as index_xegVSSHbXuw1Gi1j4Z_BvYzSYgX48uGteXDF_45naQBEMeta } from "/app/pages/app/relatorios/index.vue?macro=true";
import { default as forgot_45passwordCSWbKn9J3J_B220JzyKrtw7YYrymJGKEwS0HPhIK87AMeta } from "/app/pages/auth/forgot-password.vue?macro=true";
import { default as portal_45pacientewQpn9mSGDXEA72AD0z6AL7rHy6H0Rl7rC8HWghbPguQMeta } from "/app/pages/auth/portal-paciente.vue?macro=true";
import { default as primeiro_45acesso_RslppNnGy5bmuK2PnXP4TlAj62w4Ko7z0FsCZsdE0oMeta } from "/app/pages/auth/primeiro-acesso.vue?macro=true";
import { default as agendaMqkpb3lF0xoaTqoFpxIByVPzxrlmVH1ZVqHt_45urE2LIMeta } from "/app/pages/app/relatorios/agenda.vue?macro=true";
import { default as nutricaouRm9jwIXmULT9Pzu2u_VjUJGI1hFMhIC0lm0xVOt8DwMeta } from "/app/pages/app/relatorios/nutricao.vue?macro=true";
import { default as ocupacaoTmH62i6Aql7hK3I5jnsAlfEi3IcOzwhym7jtXP5tpt0Meta } from "/app/pages/app/relatorios/ocupacao.vue?macro=true";
import { default as repassesNsoCBhj6h16vvyDIgx26fs6y7CCdUdcb4ucGmYTk8RIMeta } from "/app/pages/app/relatorios/repasses.vue?macro=true";
import { default as selecionar_45clinicaQjqIysghKzePgmEqn2oKCpOp4PTtVXGHW1hwt5auKEEMeta } from "/app/pages/auth/selecionar-clinica.vue?macro=true";
import { default as profissionaisveQBlGlAooSSPOOuL1JCAGtWHcc1h6demI4b8v8UkKsMeta } from "/app/pages/app/equipe/profissionais.vue?macro=true";
import { default as comissoesH2zgwS60DURP_wdys3MTdMnkzIvduKDW_45ZI8R9S9yKUMeta } from "/app/pages/app/relatorios/comissoes.vue?macro=true";
import { default as pacientesBmOB18cceELa_4FYwOHQ1HJ21SWycyFEzvJTfHUaaacMeta } from "/app/pages/app/relatorios/pacientes.vue?macro=true";
import { default as abordagensslVi9s5XQ7LFyuvikoCqV5sBePjVe_45NwfXVSlHUNBooMeta } from "/app/pages/app/relatorios/abordagens.vue?macro=true";
import { default as disponibilidadewna_45mwO2rY2dzGpZtfRmNqzmmlWi7FA7balBGrfOI3oMeta } from "/app/pages/app/agenda/disponibilidade.vue?macro=true";
import { default as faturamentoFUpCzRNVy4mQXr7SJRe5UY1XBndp4U7z8F_kp3AFIpMMeta } from "/app/pages/app/relatorios/faturamento.vue?macro=true";
import { default as dermatologiac_45O6HANGDIh7CRaaPxP8KetPa80mOl5J50iL7U_45f_45IAMeta } from "/app/pages/app/relatorios/dermatologia.vue?macro=true";
import { default as fisioterapiaKXrlEEgF7Cf_VsCV4MeF9P_rIE9zXNniHmKNqXsnIHsMeta } from "/app/pages/app/relatorios/fisioterapia.vue?macro=true";
import { default as inadimplenciar6fgGM7ewxficPAW4XHUu7W3Z3SDwOaS_45a6_45y2qLx9AMeta } from "/app/pages/app/relatorios/inadimplencia.vue?macro=true";
import { default as produtividade9J1ORs4m_e4CMR7ZQ7z57mZQsxo_45Y1nH7X_45pbOQfvSEMeta } from "/app/pages/app/relatorios/produtividade.vue?macro=true";
import { default as sinais_45vitais9vXof1XW3fOKlKF2qXAOhbi_8hWYZQri8D0VGH5KKvIMeta } from "/app/pages/app/relatorios/sinais-vitais.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "app-perfil",
    path: "/app/perfil",
    meta: { ...(perfileewM5Q23l5PBJDz4_45c6UX2kJ9M7l_45vsVTSxI29qHS88Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/perfil.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: { ...(loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "planos",
    path: "/planos",
    meta: indexk3qjL_45EPugk1CN1aNW9cdx4b2Y5dGkwkCKt1AHcEd0EMeta || {},
    component: () => import("/app/pages/planos/index.vue")
  },
  {
    name: "app-dashboard",
    path: "/app/dashboard",
    meta: { ...(dashboardE7ZV2C80zylvQncoM_JXQBzpHJsDlfXFAtT_4562Q8qOYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/dashboard.vue")
  },
  {
    name: "patient",
    path: "/patient",
    meta: { ...(indexJShk27dRSWfsze5T07DMDSKRnqsALdb8h6oYoL56uS0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/patient/index.vue")
  },
  {
    name: "app-chat",
    path: "/app/chat",
    meta: { ...(indexZw_2HO0SGP7IX_45I0OpXWUbnLJZ9gO_Q62StTRt1MiBYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/chat/index.vue")
  },
  {
    name: "app-financeiro",
    path: "/app/financeiro",
    meta: { ...(financeiroKO7wsko16NUgDQHACZLu_45wA68Vq_iSBUyjs2vF9GdewMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/financeiro.vue")
  },
  {
    name: "app-prontuario",
    path: "/app/prontuario",
    meta: { ...(prontuarioAU0ay0bBcrEfJsYNetKfeM35cvShlb5xjy8iFmg9WOgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/prontuario.vue")
  },
  {
    name: "patient-agenda",
    path: "/patient/agenda",
    meta: { ...(agendaqXdXRBp_45P3_RlP3cTgm07H7x42VKfBz_45Nz8OWZn_45VrsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/patient/agenda.vue")
  },
  {
    name: "patient-diario",
    path: "/patient/diario",
    meta: { ...(diario4hRfFo_79RRdWkRWjyABRO9WCw75fFOAVWv__3ILROUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/patient/diario.vue")
  },
  {
    name: "patient-laudos",
    path: "/patient/laudos",
    meta: { ...(laudosHTjpCDVKBOlPMYJUjaBqHLZd1MWUPdkvykaN9__8uw4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/patient/laudos.vue")
  },
  {
    name: "patient-perfil",
    path: "/patient/perfil",
    meta: { ...(perfilexwVtMvcC6Qp7PfP1fPIp0UdkttAT9hsoqv1dIWsR7gMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/patient/perfil.vue")
  },
  {
    name: "patient-termos",
    path: "/patient/termos",
    meta: { ...(termosFEzF7EFVlrnJ5pqNyqEcKfh06uqOkIkkIG_bDPnTP1oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/patient/termos.vue")
  },
  {
    name: "app-agenda-id",
    path: "/app/agenda/:id()",
    meta: { ...(_91id_93IHAkhNdirUMJfFAZyhVUkhwpP4NEA_45vx68HbLj1isqQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/agenda/[id].vue")
  },
  {
    name: "app-agenda-fila",
    path: "/app/agenda/fila",
    meta: { ...(fila05ayjfPF4fwJPxm7I__45QlvtxGrRBYgkq6AfcGMdD3k8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/agenda/fila.vue")
  },
  {
    name: "app-agenda-novo",
    path: "/app/agenda/novo",
    meta: { ...(novoAyOLnF5gexgJqVZiatSD1LgevnCwyu1esPy_hNn1y8cMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/agenda/novo.vue")
  },
  {
    name: "auth-onboarding",
    path: "/auth/onboarding",
    meta: { ...(onboardingQcdr3TGwvGjMWxYkSzkIDOfyVHLITibtVzcIOyC8gFMMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/auth/onboarding.vue")
  },
  {
    name: "auth-verify-2fa",
    path: "/auth/verify-2fa",
    meta: { ...(verify_452faN9EJkZ35rnsc7Ej2BoOCjjMCYUMs5M4lJADXBc22_45xMMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/auth/verify-2fa.vue")
  },
  {
    name: "app-agenda",
    path: "/app/agenda",
    meta: { ...(indexCxnNs9xL3iKl5vgqQp6KsmuO4PneoOpXRe6dMW0S1IYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/agenda/index.vue")
  },
  {
    name: "app-notificacoes",
    path: "/app/notificacoes",
    meta: { ...(notificacoesP1pUvjWPoQW0eezFHHry__45NjFuwUdKzjooiha_QNDykMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/notificacoes.vue")
  },
  {
    name: "app-testes",
    path: "/app/testes",
    meta: { ...(indexF1yEq2u7f1C87YLhNMmTgkiuLUM_45xyAPIMbGM_45A3qWoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/testes/index.vue")
  },
  {
    name: "verificar-code",
    path: "/verificar/:code()",
    meta: { ...(_91code_93lqD_45BDvWwunPNmSl0uPQFjr6EIOhne_KAK2qj25_452vYMeta || {}), ...{"middleware":[]} },
    component: () => import("/app/pages/verificar/[code].vue")
  },
  {
    name: "app-billing",
    path: "/app/billing",
    meta: { ...(indexwjI4loSb7mMIH8poxQSfscmChVmGllhUdVGf6KXEK8cMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/billing/index.vue")
  },
  {
    name: "app-configuracoes",
    path: "/app/configuracoes",
    meta: { ...(configuracoes0GeQWU2LMjFYmopLG0tcBAXahkFJ7KHrdyP3jZuHlLYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/configuracoes.vue"),
    children: [
  {
    name: "app-configuracoes-perfil",
    path: "perfil",
    meta: { ...(perfilxWbajx_EBAtZ77_45r4PLSOQVsICTuIOPmZodr_4545QHk4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/configuracoes/perfil.vue")
  },
  {
    name: "app-configuracoes-permissoes",
    path: "permissoes",
    meta: { ...(permissoesuEmYyxwe1_45sURYWwU5GZWSqp2ouR2hGqoGZ4JAdyGpgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/configuracoes/permissoes.vue")
  }
]
  },
  {
    name: "auth-google-proxy",
    path: "/auth/google-proxy",
    meta: google_45proxy7NrT_CY4XTdbqIH4J7cnMkPzyTtn8uiY_JtCDWRhc_45wMeta || {},
    component: () => import("/app/pages/auth/google-proxy.vue")
  },
  {
    name: "confirmar-token",
    path: "/confirmar/:token()",
    meta: _91token_93gfyTk9RLV0P5NhG6G26szJgdhvwRquJCf_92w0aaK6wMeta || {},
    component: () => import("/app/pages/confirmar/[token].vue")
  },
  {
    name: "app-pacientes-id",
    path: "/app/pacientes/:id()",
    meta: { ...(_91id_933Gp6OW_DRWxz_45BCEiubBHGrfCTKZdJvurtaaw_QT7xMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/pacientes/[id].vue")
  },
  {
    name: "app-pacientes-novo",
    path: "/app/pacientes/novo",
    meta: { ...(novolMJqSOn7250iaW0lFfkP8pwHg_45Y6pI7X2qm4wklEX6gMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/pacientes/novo.vue")
  },
  {
    name: "auth-login-patient",
    path: "/auth/login-patient",
    meta: { ...(login_45patient5GX7LaTM629cXfeGuayZ32G54_ZfPV3kODO7djWpt6kMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/auth/login-patient.vue")
  },
  {
    name: "patient-financeiro",
    path: "/patient/financeiro",
    meta: { ...(financeiroad_e4p8ipb0hEKeuXg_45m8m2NgbxKcwF59QP9U4opGxwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/patient/financeiro.vue")
  },
  {
    name: "patient-prontuario",
    path: "/patient/prontuario",
    meta: { ...(prontuarioS7MRm574px9oVRlS5m3QoFBuxoBto5R32CK73DlWhEsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/patient/prontuario.vue")
  },
  {
    name: "app-auditoria",
    path: "/app/auditoria",
    meta: { ...(indexOQ_45n7BeLg481nwu534ZdiQtF5y_45TfRCpWpP_45TJtlUaYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/auditoria/index.vue")
  },
  {
    name: "app-checklist",
    path: "/app/checklist",
    meta: { ...(indexBn04P8TSS7Lwfe010m9Xo_JkdttFSBP0AZpk5Nq047EMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/checklist/index.vue")
  },
  {
    name: "app-equipe-usuarios",
    path: "/app/equipe/usuarios",
    meta: { ...(usuariostNZGNhzAQeafkZE8etZY7PgzrhIsNIfvaEk7FawTyuUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/equipe/usuarios.vue")
  },
  {
    name: "app-pacientes",
    path: "/app/pacientes",
    meta: { ...(index7pGc2Xv3_450qG_45_45ely4CFBgxFsHHcKF0LoQ0DprWOq9AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/pacientes/index.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: { ...(reset_45passwordNpUsiQybcTLi_45Ke3wh24gyldOA9IXhGjC1yM32hGDDMMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/auth/reset-password.vue")
  },
  {
    name: "app-agenda-bloqueios",
    path: "/app/agenda/bloqueios",
    meta: { ...(bloqueiosP00qJqwgImfX1Krh4rW4MtNc2liCl2jrVM2Up4R_45d0cMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/agenda/bloqueios.vue")
  },
  {
    name: "app-relatorios",
    path: "/app/relatorios",
    meta: { ...(index_xegVSSHbXuw1Gi1j4Z_BvYzSYgX48uGteXDF_45naQBEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/index.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: { ...(forgot_45passwordCSWbKn9J3J_B220JzyKrtw7YYrymJGKEwS0HPhIK87AMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-portal-paciente",
    path: "/auth/portal-paciente",
    meta: { ...(portal_45pacientewQpn9mSGDXEA72AD0z6AL7rHy6H0Rl7rC8HWghbPguQMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/auth/portal-paciente.vue")
  },
  {
    name: "auth-primeiro-acesso",
    path: "/auth/primeiro-acesso",
    meta: { ...(primeiro_45acesso_RslppNnGy5bmuK2PnXP4TlAj62w4Ko7z0FsCZsdE0oMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/auth/primeiro-acesso.vue")
  },
  {
    name: "app-relatorios-agenda",
    path: "/app/relatorios/agenda",
    meta: { ...(agendaMqkpb3lF0xoaTqoFpxIByVPzxrlmVH1ZVqHt_45urE2LIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/agenda.vue")
  },
  {
    name: "app-relatorios-nutricao",
    path: "/app/relatorios/nutricao",
    meta: { ...(nutricaouRm9jwIXmULT9Pzu2u_VjUJGI1hFMhIC0lm0xVOt8DwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/nutricao.vue")
  },
  {
    name: "app-relatorios-ocupacao",
    path: "/app/relatorios/ocupacao",
    meta: { ...(ocupacaoTmH62i6Aql7hK3I5jnsAlfEi3IcOzwhym7jtXP5tpt0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/ocupacao.vue")
  },
  {
    name: "app-relatorios-repasses",
    path: "/app/relatorios/repasses",
    meta: { ...(repassesNsoCBhj6h16vvyDIgx26fs6y7CCdUdcb4ucGmYTk8RIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/repasses.vue")
  },
  {
    name: "auth-selecionar-clinica",
    path: "/auth/selecionar-clinica",
    meta: selecionar_45clinicaQjqIysghKzePgmEqn2oKCpOp4PTtVXGHW1hwt5auKEEMeta || {},
    component: () => import("/app/pages/auth/selecionar-clinica.vue")
  },
  {
    name: "app-equipe-profissionais",
    path: "/app/equipe/profissionais",
    meta: { ...(profissionaisveQBlGlAooSSPOOuL1JCAGtWHcc1h6demI4b8v8UkKsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/equipe/profissionais.vue")
  },
  {
    name: "app-relatorios-comissoes",
    path: "/app/relatorios/comissoes",
    meta: { ...(comissoesH2zgwS60DURP_wdys3MTdMnkzIvduKDW_45ZI8R9S9yKUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/comissoes.vue")
  },
  {
    name: "app-relatorios-pacientes",
    path: "/app/relatorios/pacientes",
    meta: { ...(pacientesBmOB18cceELa_4FYwOHQ1HJ21SWycyFEzvJTfHUaaacMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/pacientes.vue")
  },
  {
    name: "app-relatorios-abordagens",
    path: "/app/relatorios/abordagens",
    meta: { ...(abordagensslVi9s5XQ7LFyuvikoCqV5sBePjVe_45NwfXVSlHUNBooMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/abordagens.vue")
  },
  {
    name: "app-agenda-disponibilidade",
    path: "/app/agenda/disponibilidade",
    meta: { ...(disponibilidadewna_45mwO2rY2dzGpZtfRmNqzmmlWi7FA7balBGrfOI3oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/agenda/disponibilidade.vue")
  },
  {
    name: "app-relatorios-faturamento",
    path: "/app/relatorios/faturamento",
    meta: { ...(faturamentoFUpCzRNVy4mQXr7SJRe5UY1XBndp4U7z8F_kp3AFIpMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/faturamento.vue")
  },
  {
    name: "app-relatorios-dermatologia",
    path: "/app/relatorios/dermatologia",
    meta: { ...(dermatologiac_45O6HANGDIh7CRaaPxP8KetPa80mOl5J50iL7U_45f_45IAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/dermatologia.vue")
  },
  {
    name: "app-relatorios-fisioterapia",
    path: "/app/relatorios/fisioterapia",
    meta: { ...(fisioterapiaKXrlEEgF7Cf_VsCV4MeF9P_rIE9zXNniHmKNqXsnIHsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/fisioterapia.vue")
  },
  {
    name: "app-relatorios-inadimplencia",
    path: "/app/relatorios/inadimplencia",
    meta: { ...(inadimplenciar6fgGM7ewxficPAW4XHUu7W3Z3SDwOaS_45a6_45y2qLx9AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/inadimplencia.vue")
  },
  {
    name: "app-relatorios-produtividade",
    path: "/app/relatorios/produtividade",
    meta: { ...(produtividade9J1ORs4m_e4CMR7ZQ7z57mZQsxo_45Y1nH7X_45pbOQfvSEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/produtividade.vue")
  },
  {
    name: "app-relatorios-sinais-vitais",
    path: "/app/relatorios/sinais-vitais",
    meta: { ...(sinais_45vitais9vXof1XW3fOKlKF2qXAOhbi_8hWYZQri8D0VGH5KKvIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/app/relatorios/sinais-vitais.vue")
  }
]